export default "__VITE_ASSET__BdBQ9DVM__"